import React from 'react';
import { CriteriaCard } from '../Criteria';
export default function CriteriaSection() {
    return React.createElement(CriteriaCard, { name: "criteria", root: true, alone: true });
}
